import React from "react";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import { UserRoundIcon } from "lucide-react";
const MapComponent = ({ location, data }) => {
  const defaultLoc = {
    lat: Number(location?.latitude) || 19.1100524,
    lng: Number(location?.longitude) || 72.8834071,
  };

  return (
    <APIProvider apiKey={process.env.REACT_APP_GMAP_API_KEY}>
      <Map
        mapId={process.env.REACT_APP_GMAP_MAP_ID}
        style={{ height: "100vh", width: "100%" }}
        defaultZoom={15}
        defaultCenter={defaultLoc}
      >
        {/* {locations.map((marker, i) => */}
        {location?.latitude && location?.longitude ? (
          <AdvancedMarker
            // key={i}
            position={{
              lat: Number(location?.latitude),
              lng: Number(location?.longitude),
            }}
            title={`${data?.first_name} ${data?.last_name}`}
          >
            {/* <img
                src={userImage}
                alt={marker.title}
                style={{ width: "40px", height: "30px" }}
              /> */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 5,
              }}
            >
              <div
                style={{
                  height: 40,
                  width: 40,
                  borderRadius: "50%",
                  backgroundColor: "#3e424b",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <UserRoundIcon />
              </div>
              {data?.first_name} {data?.last_name}
            </div>

            {/* <UserRoundIcon strokeWidth={2} style={{ color: "red" }} /> */}
          </AdvancedMarker>
        ) : null}
        {/* )} */}
      </Map>
    </APIProvider>
  );
};
export default MapComponent;
